import {PARSE_PROP_CONF_KEY, PACKAGE_NAME} from '../../constants';
import isValuePropertySelector from './isValuePropertySelector';
import {
	sandbox,
	locations,
	toLower,
	kebabCase,
	allLogTypes as logTypes
} from '@servicenow/ui-internal';
import log from '../../log';
import {parseRefProperty} from './refProperty';
import {default as validParseTypes} from './types';
import parse from './parse';

export default function parseProperty(name, value, def = {}, host, dispatch) {
	const unstableParse = def[PARSE_PROP_CONF_KEY];
	const schemaType = def.schema && def.schema.type;
	const isValidParseType = validParseTypes.includes(schemaType);
	const resolvedValue = def.resolveRef ? parseRefProperty(host, name, value) : value;
	const shouldUnstableParse =
		(unstableParse || validParseTypes.includes(schemaType)) &&
		!isValuePropertySelector(resolvedValue) &&
		typeof resolvedValue === 'string';

	if (shouldUnstableParse && isValidParseType && !host.hasAttribute(kebabCase(name))) {
		const component = `<${toLower(host.tagName)} />`;
		log(
			`For property ${name} on component ${component}: expected to be type ${schemaType} but received string. ${PACKAGE_NAME} will attempt to parse this value, but you should set this to the correct type.`,
			{level: logTypes.WARN, host, origin: 'parseProperty'}
		);
	}

	return shouldUnstableParse
		? sandbox(parse, {
				args: [resolvedValue, schemaType, name, host.tagName],
				host,
				dispatch,
				location: locations.PROPERTY,
				details: {parse: true, name},
				log
		  })
		: resolvedValue;
}
